
import { supabase } from "@/lib/supabase";

// Debug utility to test message format updates
export const debugMessageFormatUpdate = async (conversationId: string) => {
  console.log("=== DEBUG: Message Format Update ===");
  
  try {
    // 1. Check current user
    const { data: user, error: userError } = await supabase.auth.getUser();
    if (userError) {
      console.error("User error:", userError);
      return;
    }
    console.log("Current user:", user.user?.id);
    
    // 2. Check if record exists and user owns it
    const { data: record, error: readError } = await supabase
      .from("refund_requests")
      .select("*")
      .eq("id", conversationId)
      .single();
      
    if (readError) {
      console.error("Read error:", readError);
      return;
    }
    
    console.log("Record found:", {
      id: record.id,
      user_id: record.user_id,
      message_format: record.message_format,
      updated_at: record.updated_at
    });
    
    console.log("User owns record:", record.user_id === user.user?.id);
    
    // 3. Test update
    const { data: updateResult, error: updateError } = await supabase
      .from("refund_requests")
      .update({ 
        message_format: record.message_format === "email" ? "chat" : "email",
        updated_at: new Date().toISOString()
      })
      .eq("id", conversationId)
      .select();
      
    if (updateError) {
      console.error("Update error:", updateError);
      return;
    }
    
    console.log("Update result:", updateResult);
    
    // 4. Verify the update
    const { data: verifyRecord, error: verifyError } = await supabase
      .from("refund_requests")
      .select("message_format, updated_at")
      .eq("id", conversationId)
      .single();
      
    if (verifyError) {
      console.error("Verify error:", verifyError);
      return;
    }
    
    console.log("Verified record:", verifyRecord);
    
  } catch (error) {
    console.error("Debug error:", error);
  }
  
  console.log("=== END DEBUG ===");
};

// Add this to window for easy testing
if (typeof window !== 'undefined') {
  (window as any).debugMessageFormat = debugMessageFormatUpdate;
}
